export const MedicineList = {
  MedicineType: {
    Prescription: '処方薬',
    OverTheCounter: '市販薬',
  },
  Button: {
    Search: '絞り込み',
    Register: 'お薬を登録する',
    Insert: '登録する',
    Update: '更新する',
    Delete: '削除する',
    Alarm: '服薬アラームを設定する',
    SearchMedicine: '検索する',
    IdConfirmation: '本人確認を行う',
    LaterIdConfiirmation: '今は行わない',
    TakePicture: '撮影',
    Next: '次へ',
    NotNow: '今は本人確認を行わない',
    RequestIdConfirmation: '本人確認を依頼する',
    Edit: '編集する',
    Save: '保存する',
    AdditionalMedicine: '処方薬・市販薬・サプリ追加',
    MedicineListLink: '本人確認、問診表',
    Yet: '未',
    Done: '済',
    Foget: '忘れ',
  },
  Register: {
    Prescription: {
      QR: 'QRコード読み込み',
      Manual: '写真を登録する',
    },
    OverTheCounter: {
      BarCode: 'バーコード読み込み',
      Manual: '自分で入力する',
    },
  },
  PageName: {
    List: 'お薬手帳',
    Register: 'お薬の登録',
    Manual: {
      Insert: '処方薬の登録',
      Update: '処方薬の更新',
    },
    OverTheCounter: {
      Insert: '市販薬の登録',
      Update: '市販薬の更新',
    },
    Detail: 'お薬の詳細',
    Search: 'お薬情報：絞り込み',
    IdConfirmation: '本人確認',
  },
  Label: {
    Insert: '以下の情報を入力し、「登録する」を押してください。',
    Update: '以下の情報を入力し、「更新する」を押してください。',
    UserName: '患者さまのお名前',
    MedicineName: 'お薬の名前',
    Picture: {
      Title: {
        Prescription: 'お薬情報の写真',
        OverTheCounter: 'お薬の写真',
      },
      Supplement:
        '薬局からもらった薬剤情報提供文書の写真をアップロードしてください。',
    },
    DispensingDate: 'お薬をもらった日',
    StartDate: '服薬開始日',
    EndDate: '服薬終了日',
    Pharmacy: 'お薬をもらった薬局',
    PurchaseStore: '購入店舗',
    Memo: '服薬メモ',
    PharmacyMemo: '薬局メモ',
    PrescriptionMedicine: '処方薬',
    Share: {
      Title: '薬局にメモを共有する',
      Content: '薬剤師にメモを共有する',
      Supplement:
        'お薬手帳の閲覧を許可した薬局に服薬メモの内容が共有されます。',
      Done: '薬局に共有中',
      Yet: '薬局に未共有',
    },
    PartialMatch: 'お薬名（部分一致）',
    DateMatch: 'お薬をもらった日・服薬開始日',
    PharmacyLinked: '薬局連携',
    ManualInput: '手動登録',
    MedicineStatus: '服薬状況',
    MemoSample: '自分でメモを追加できます。',
  },
  Text: {
    Pharmacy: '薬局名',
    Memo: '気になることなどがあれば入力してください',
  },
  PrescriptionDetail: {
    DoctorName: '医師名：',
    Department: '診療科名：',
    Explanation: 'お薬の説明',
    ListName: '処方薬',
    Dosage: '用法',
    Dose: '用量',
    DispensingQuantity: '調剤数量',
    DosageForm: '剤形',
    MedicineSupplement: 'お薬の補足',
    DosageSupplement: '用法の補足',
  },
  Dialog: {
    Insert: {
      Text: 'お薬を登録しました。',
      Button: 'OK',
    },
    InsertError: {
      Text: 'お薬の登録に失敗しました。',
      Button: 'OK',
    },
    BarCodeError: {
      Text: 'お薬情報が取得できませんでした。手入力を行ってください。',
    },
    Update: {
      Text: 'お薬を更新しました。',
      Button: 'OK',
    },
    Warning: {
      Text: 'お薬を削除しますか？',
    },
    Delete: {
      Text: 'お薬を削除しました。',
      Button: 'OK',
    },
    AboutAutoRegister: {
      Title: 'お薬の自動登録について',
      Text: '本人確認を行うことで、薬局でお薬を受け取った後、調剤されたお薬情報が自動でアプリに登録される機能です。\n※薬局によっては自動登録できない場合がございます。',
    },
    ConfirmRequest: {
      Text: '本人確認を送信しますか？',
      OK: 'OK',
      Cancel: 'キャンセル',
    },
    RegisterIdConfirmation: {
      Title: '本人確認の依頼を送信しました',
      Text: '本人確認が完了出来次第お知らせします。また本人確認できない場合は再登録が必要になります。',
      Button: 'OK',
    },
    Confirm: '服薬アラームにお薬が登録されているため、削除できません。',
    Deleted: '対象のお薬は既に削除されています。',
    FinishOrCanceled:
      '対象の調剤予約は既に完了もしくはキャンセルされています。',
    HiddenConfirmation: {
      Text: '処方を非表示にしますか？\n※お薬手帳の画面を見せる際、薬局や医療機関に秘匿したい場合に非表示にできます。\n※秘匿した情報は薬局・医療機関が服薬指導等に活用できなくなる可能性があります。',
    },
    RedisplayConfirmation: {
      Text: '処方を再表示しました。',
    },
  },
  DosageForm: {
    Oral: '内服',
    Drop: '内滴',
    UseAsNeeded: '屯服',
    Injection: '注射',
    External: '外用',
    Infusodecoction: '浸煎',
    HotWater: '湯',
    Material: '材料',
    Other: 'その他',
    Quantity: {
      Day: '1日量',
      All: '全量',
      Times: '1回量',
    },
  },
  GooGleSearch: {
    explain:
      '薬剤名に「くすりのしおり」のキーワードを追加してGoogle検索を行います。\n「くすりのしおり(R)」とは、一般社団法人くすりの適正使用協議会が運営する、処方薬に関する説明サイトです。',
    check: '次回からこの画面を表示しない',
    keyWord: '+くすりのしおり',
  },
  IdConfirmation: {
    Breadcrumb: {
      User: '本人情報の登録',
      InsuranceCard: '確認方法の選択',
      Pharmacy: '薬局の登録',
    },
    UserEdit: {
      Explain:
        '本人確認書類記載の本人情報を入力欄にご記入ください。入力に誤りがあると、本人確認できない場合があります。',
      Resend:
        '再度、本人確認書類記載の本人情報を入力欄にご記入ください。入力に誤りがあると、本人確認できない場合があります。',
    },
    Pharmacy: {
      Register: 'かかりつけ薬局を登録してください。',
      ConfirmRegist: '下記の薬局をかかりつけ薬局として登録します。',
    },
    InvalidMessage: {
      Resend:
        '入力した本人確認情報と本人確認書類の情報が一致しなかったため、本人確認ができませんでした。',
      ResendOffline: '本人確認ができませんでした。',
    },
    ConfirmationType: {
      Online: {
        Title: '本人確認書類の写真を送付し本人確認を行う',
        Description:
          '※マイナンバーカード、運転免許証等の本人確認ができる書類を撮影し、写真を追加してください。',
      },
      Offline: {
        Title: '対面で本人確認を行う',
        Description:
          '※薬局に本人確認できる書類（処方箋も可）をお持ちください。',
      },
    },
  },
  Validation: {
    InvalidEndDate: '服薬開始日より後の日付を指定してください。',
  },
  SecretInfo: {
    Message: '非表示の処方があります。',
  },
};
